(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Brick', Brick);

    Brick.$inject = ['$resource'];

    function Brick ($resource) {
        var resourceUrl =  'api/bricks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
